import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Spinner from "./Spinner";
import axios from 'axios'
import { useAuth } from "../context/auth";
export default function PrivateRoute() {



    const [ok, setOk] = useState(false);
    const [auth, setAuth] = useAuth();

    useEffect(() => {
        const authCheck = async () => {
            const res = await axios.get("https://bablu-server.onrender.com/auth/userAuth");
            if (res.data.ok) {
                setOk(true);
            } else {
                setOk(false);
            }
        };
        if (auth?.token) authCheck();
    }, [auth?.token]);

    return ok ? <Outlet /> : <Spinner />;
}